import React, { useEffect } from "react";
import logo from './logo.svg';
import './App.css';

function App() {
  useEffect(() => {
    window.location.href = "https://painel.sismoney.com/";
  }, []);

  return null; // Não renderiza nada, só redireciona
}

export default App;
